import { EarlyBirdOfferBuilderState } from "app/pages/EarlyBirdOfferBuilder/modules/EarlyBirdOfferBuilder/state";
import { validateRules } from "app/pages/EarlyBirdOfferBuilder/validation";

function getRoot(state: any): EarlyBirdOfferBuilderState {
    return state.earlyBirdOfferBuilder;
}

export function getRules(state: any) {
    return getRoot(state).rules;
}

export function getYear(state: any) {
    return getRoot(state).year;
}

export function getDivisionId(state: any) {
    return getRoot(state).divisionId;
}

export function getLookups(state: any) {
    return getRoot(state).lookups;
}

export function getEditingConditionUiId(state: any) {
    return getRoot(state).editingConditionUiId;
}

export function getDirty(state: any): boolean {
    return getRoot(state).dirty ?? false;
}

export function getEditingCondition(state: any) {
    const root = getRoot(state);
    const uiId = root.editingConditionUiId;
    if (!uiId) return null;
    for (let i = 0; i < root.rules.length; i++) {
        const rule = root.rules[i];
        const inc = rule.include.find((c) => (c as any).uiId === uiId);
        if (inc) return { ruleIndex: i, lane: "include" as const, condition: inc };
        const exc = rule.exclude.find((c) => (c as any).uiId === uiId);
        if (exc) return { ruleIndex: i, lane: "exclude" as const, condition: exc };
    }
    return null;
}

export function getValidationErrors(state: any): string[] {
    return validateRules(getRoot(state).rules);
}

export function hasValidationErrors(state: any): boolean {
    return getValidationErrors(state).length > 0;
}